// extracted by mini-css-extract-plugin
export default {"Filters":"_Pdhk_K98lpjEbP_wuzz","Results":"KQTi4vcoZVzydzQjW9nQ","ResultsList":"KoaI_gMCES1IexGl6FTS","Results--withCards":"zHwq0xxU4QV2b6OeQDQp","StudyCard":"BzVcRyOWzc89MoxfIGmK"};